const formatters = {
  Cohort: (cohort) => cohort.event_name,
  Organization: (org) => org.name,
};

export default function modelAutocompleteFormatter(model, object) {
  const formatter = formatters[model];
  if (!formatter) {
    throw Error(`No formatter found for model '${model}'!`);
  }

  if (!object) {
    return null;
  }
  return {
    uuid: object.uuid,
    label: formatter(object),
  };
}
